/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case-insensitive`)
};

const es_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin distinción de mayúsculas`)
};

const de_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groß-/Kleinschreibung ignorieren`)
};

const nl_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onafhankelijk van hooflettter`)
};

const fr_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insensible à la casse`)
};

const it_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza distinzione maiuscole/minuscole`)
};

const pt_br2_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem diferenciação entre maiúsculas e minúsculas`)
};

const pt_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem diferença de maiúsculas/minúsculas`)
};

const ja_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字小文字を区別しない`)
};

const zh_wf_case = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不区分大小写`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_case = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_case(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_case", locale)
	if (locale === "en") return en_wf_case(inputs)
	if (locale === "es") return es_wf_case(inputs)
	if (locale === "de") return de_wf_case(inputs)
	if (locale === "nl") return nl_wf_case(inputs)
	if (locale === "fr") return fr_wf_case(inputs)
	if (locale === "it") return it_wf_case(inputs)
	if (locale === "pt-BR") return pt_br2_wf_case(inputs)
	if (locale === "pt") return pt_wf_case(inputs)
	if (locale === "ja") return ja_wf_case(inputs)
	return zh_wf_case(inputs)
};